/* @jsx h */
import { defineComponent, ref, onMounted, h } from "vue";
import { api } from "@app/data/index";
import { WeeklyPerformanceDatum } from "@lemmonhq/types";
import {
  WeeklyHeatmapFilters,
  type WeeklyHeatmapFiltersProps,
} from "./WeeklyHeatmapFilters";
import { WeeklyHeatmapChart } from "./WeeklyHeatmapChart";
import { getDateRange } from "@lemmonhq/uikit";

export const WeeklyHeatmapPage = defineComponent({
  name: "WeeklyHeatmapPage",
  setup() {
    const loading = ref(true);
    const data = ref<WeeklyPerformanceDatum[]>([]);
    const dateRange = getDateRange("this_year");
    const filters = ref<WeeklyHeatmapFiltersProps["filters"]>({
      dateRange: {
        type: "this_year",
        startDate: dateRange.startDate,
        endDate: dateRange.endDate,
      },
      metricInput: "revenue",
    });

    const fetchData = async () => {
      loading.value = true;
      try {
        const result = await api.getWeeklyPerformance({
          start_date_input: filters.value.dateRange.startDate,
          end_date_input: filters.value.dateRange.endDate,
          metric_input: filters.value.metricInput,
          service_method_input: filters.value.serviceType,
          product_type_input: filters.value.orderType,
        });
        data.value = result;
      } catch (error) {
        console.error("Failed to fetch weekly performance:", error);
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      fetchData();
    });

    return () => (
      <div class="w-full space-y-8">
        <div class="border-b  px-2 xl:px-4 pb-4">
          <WeeklyHeatmapFilters
            filters={filters.value}
            onFiltersChange={(newFilters) => {
              filters.value = newFilters;
              fetchData();
            }}
          />
        </div>
        <div class="  px-2 xl:px-4">
          <WeeklyHeatmapChart
            data={data.value}
            loading={loading.value}
            filters={filters.value}
          />
        </div>
      </div>
    );
  },
});
